Object.defineProperty(exports, '__esModule', {
  value: true,
});

const Basket = function ShopifyQuickCart(configuration) {
  const config = configuration || {};
  this.basketNamespace = 'basket';
  this.itemsNamespace = 'items';
  this.deliveryDateNamespace = 'deliveryDate';
  this.optimizeNamespace = 'optimize';
  this.fulfillmentNamespace = 'fulfillmentCenter';
  this.displayShippingNamespace = 'displayShipping';
  this.packageProtectionNamespace = 'packageProtection';
  this.UTMnamespace = 'utm';
  this.basket = store.namespace(this.basketNamespace);
  this._update();

  this.products = config.products;

  return this;
};

Basket.prototype.add = function(opts) {
  const key = this.itemsNamespace;
  const items = this.basket.get(key) || [];
  let item = {};
  let itemExists = false;

  // increase qty if item is in basket
  items.forEach((_item) => {
    if (_item.id === opts.variant.id) {
      _item.quantity += opts.quantity;
      itemExists = true;
    }
  });

  if (!itemExists) {
    item = this._generateLineItem(opts.variant, opts.product, opts.properties, opts.quantity);
    items.push(item);
  }

  this.basket.set(key, items);

  if (!opts.defer) {
    this._update();
  }
};

Basket.prototype.changeItemByLine = function(opts) {
  const key = this.itemsNamespace;
  const items = this.basket.get(key) || [];
  const index = opts.line - 1;

  items[index].quantity = opts.quantity;
  items[index].id = opts.variantId;
  items[index].properties = opts.properties;


  this.basket.set(key, items);
  if (!opts.defer) {
    this._update();
  }
};

Basket.prototype.increment = function(opts) {
  const key = this.itemsNamespace;
  const items = this.basket.get(key) || [];

  items.forEach((_item) => {
    if (_item.id === opts.variantId) {
      _item.quantity += 1;
    }
  });

  this.basket.set(key, items);

  if (!opts.defer) {
    this._update();
  }
};

Basket.prototype.decrement = function(variantId) {
  const key = this.itemsNamespace;
  const items = this.basket.get(key) || [];

  items.forEach((_item, index) => {
    if (_item.id === variantId) {
      if (_item.quantity <= 1) {
        items.splice(index, 1);
      } else {
        _item.quantity -= 1;
      }
    }
  });

  this.basket.set(key, items);
  this._update();
};

Basket.prototype.updateQuantity = function(line, quantity) {
  const key = this.itemsNamespace;
  const items = this.basket.get(key) || [];
  const index = line - 1;

  if (quantity <= 0) {
    items.splice(index, 1);
  } else {
    items[index].quantity = quantity;
  }

  this.basket.set(key, items);
  this._update();
};

Basket.prototype.remove = function(variantId) {
  const key = this.itemsNamespace;
  const items = this.basket.get(key) || [];

  items.forEach((_item, index) => {
    if (_item.id === variantId) {
      items.splice(index, 1);
    }
  });

  this.basket.set(key, items);
  this._update();
};

Basket.prototype.empty = function() {
  const key = this.itemsNamespace;

  this.basket.set(key, []);
  this._update();
};

Basket.prototype._update = function() {
  const items = this.itemsNamespace;
  const date = this.deliveryDateNamespace;
  this.items = this.basket.get(items) || [];
  this.available_delivery_dates = this.basket.get(date) || undefined;
  this._updateItemCount(this.items);

  const updateEvent = new CustomEvent('basket:updated', {
    detail: {
      response: this,
    },
  });
  document.dispatchEvent(updateEvent);
};

Basket.prototype._updateItemCount = function(_items) {
  let count = 0;
  _items.forEach((_item) => {
    count += Number(_item.quantity);
  });
  this.item_count = count;
};

Basket.prototype._generateLineItem = function(variant, product, properties, quantity) {
  return {
    handle: product.handle,
    id: variant.id,
    image: product.featured_image,
    price: variant.price,
    product_id: product.id,
    product_title: product.title,
    properties,
    quantity: quantity || 1,
    sku: variant.sku,
    variant_title: variant.title,
  };
};

Basket.prototype.setAvailableDeliveryDates = function(date) {
  const key = this.deliveryDateNamespace;
  this.basket.set(key, date);
  this.available_delivery_dates = date;
};

Basket.prototype.unsetAvailableDeliveryDates = function(date) {
  const key = this.deliveryDateNamespace;
  this.basket.set(key, null);
  this.available_delivery_dates = undefined;
};

Basket.prototype.getOptimizeProperty = function(prop) {
  const key = this.optimizeNamespace;
  const optimize = this.basket.get(key) || {};
  return optimize[prop];
};

Basket.prototype.setOptimizeProperty = function(prop, value) {
  const key = this.optimizeNamespace;
  const optimize = this.basket.get(key) || {};
  optimize[prop] = value;
  this.basket.set(key, optimize);
};

Basket.prototype.unsetOptimizeProperty = function(prop) {
  const key = this.optimizeNamespace;
  const optimize = this.basket.get(key) || {};
  if (optimize[prop]) { delete optimize[prop]; }
  this.basket.set(key, optimize);
};

Basket.prototype.getFulfillmentCenter = function() {
  const key = this.fulfillmentNamespace;
  return this.basket.get(key);
};

Basket.prototype.setFulfillmentCenter = function(fulfillmentCenter) {
  const key = this.fulfillmentNamespace;
  this.basket.set(key, fulfillmentCenter);
};

Basket.prototype.unsetFulfillmentCenter = function() {
  const key = this.fulfillmentNamespace;
  this.basket.set(key, null);
};

Basket.prototype.getDisplayShipping = function() {
  const key = this.displayShippingNamespace;
  return this.basket.get(key);
};

Basket.prototype.setDisplayShipping = function(displayShipping) {
  const key = this.displayShippingNamespace;
  this.basket.set(key, displayShipping);
};

Basket.prototype.unsetDisplayShipping = function() {
  const key = this.displayShippingNamespace;
  this.basket.set(key, null);
};

Basket.prototype.getUTM = function(prop) {
  const key = this.UTMnamespace;
  const utm = this.basket.get(key) || {};
  return prop ? utm[prop] : utm;
};

Basket.prototype.setUTM = function(prop, value) {
  const key = this.UTMnamespace;
  const utm = this.basket.get(key) || {};
  utm[prop] = value;
  this.basket.set(key, utm, 86400);
};

Basket.prototype.unsetUTM = function(prop) {
  const key = this.UTMnamespace;
  const utm = this.basket.get(key) || {};
  if (prop) {
    if (utm[prop]) { delete utm[prop]; }
    this.basket.set(key, utm, 86400);
  } else {
    this.basket.remove(key);
  }
};

Basket.prototype.getPackageProtection = function() {
  const key = this.packageProtectionNamespace;
  return this.basket.get(key) || false;
};

Basket.prototype.setPackageProtection = function(packageProtectionEnabled) {
  const key = this.packageProtectionNamespace;
  this.basket.set(key, Boolean(packageProtectionEnabled));
};

exports.default = Basket;
